export const getNestedObject = (
  nestedObj: Record<string, unknown>,
  pathArr: Array<string>
) => {
  return pathArr.reduce(
    (obj, key) => (obj && obj[key] !== "undefined" ? obj[key] : undefined),
    nestedObj
  );
};
